export enum AuthorizationStatus {
  Error = -1,
  InitialState = 0,
  Pending = 1,
  NotAuthorized = 2,
  Authorized = 3
}
